import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

let loading // loading变量
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading() {
  loading.close()
}
// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return
  }
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: DisciplineConfig.BASE_API,
  withCredentials: true,
  timeout: 60 * 1000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json'
    }
    config.headers['x-token'] = getToken()
    if (config.loading) {
      showFullScreenLoading()
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    // 二进制数据则直接返回
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      endLoading()
      return response.data
    }

    tryHideFullScreenLoading()
    const jsonResult = response.data;
    if (!jsonResult.success) {
      // 当返回信息为未登录或者登录失效的时候重定向为登录页面
      //       if(response.data.code == 'W_100004' || response.data.message == '用户未登录或登录超时，请登录！'){
      //         router.push({
      //           path:"/",
      //           querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      //         })
      //       }
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (jsonResult.statusCode === '50008' || jsonResult.statusCode === '50012' || jsonResult.statusCode ===
        '50014') {
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject(jsonResult);
    } else {
      return jsonResult;
    }
  },
  error => {
    console.log(error);
    let errorMessage = error.message;
    if (errorMessage === 'Network Error') {
      let loginUrl = DisciplineConfig.LOGIN_URL;
      window.location.href = loginUrl;
      errorMessage = '网络异常，请重试！';
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = '网络异常，请重试！';
    } else {
      if (typeof(error) === 'string') {
        let text = JSON.parse(JSON.stringify(error)).response.status === 404 ?
          '404' :
          '网络异常，请重试！';
        errorMessage = text;
      }
    }

    Message({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    });

    endLoading()

    return Promise.reject(error)
  }
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js